@for (item of vaps; track item; let i = $index) {
  <div class="addon-expander">
    <div class="addon-expander__header">
      <a [href]="'#addon-general-field-' + item?.session_item_id" [id]="'addon-' + item?.session_item_id"
        class="addon-expander__title" data-toggle="collapse" aria-expanded="true" [ngClass]="{'collapsed': !item?.show}">
        <h6 [id]="'q' + item?.session_item_id">
          {{item?.benefit_value > 0 ? (item?.name+' '+item?.surname+ ' - ' + globalQuestionService.accounting.formatMoney(item?.benefit_value)) : 'Add Cover'}}
        </h6>
        <div class="addon-expander__cost {{ item?.price > 0 ? 'is-active' : ''}}">
          <p>
            <strong
              [class]="currentVap?.product_vaps_id + '-' + item?.session_item_id + '-price addon-price-' + currentVap?.product_vaps_id + ' addon-' + currentVap?.product_vaps_id">
            {{ globalQuestionService.accounting.formatMoney(item?.price)}}</strong> /mo
          </p>
        </div>
        <div class="addon-expander__caret">
          <svg class="icon">
            <use xlink:href="#dropdown"></use>
          </svg>
        </div>
      </a>
    </div>
    <div class="addon-expander__content collapse" [ngClass]="{'show': item?.show}" [id]="'addon-general-field-' + item?.session_item_id">
      <div class="modal-addons__item">
        <div class="form-group">
          <label>{{question?.question_copy}}</label>
          <input type="text"
            placeholder="Name"
            [(ngModel)]="item.name"
            [class]="'form-control name answers ' + question?.cent_aq_question_id"
            (ngModelChange)="onChange(i, 0)"/>
          </div>
          <div class="form-group">
            <input type="text"
              placeholder="Surname"
              [class]="'form-control surname answers ' + question?.cent_aq_question_id"
              [(ngModel)]="item.surname"
              (ngModelChange)="onChange(i, 0)"/>
            </div>
            <div class="form-group">
              <app-question-dropdown
                [showLabel]="false"
                [readOnly]="false"
                [question]="question"
                [selectedValue]="item?.selectedOption ? item?.selectedOption : ''"
                (questionAnswer)="selectChange($event, i)">
              </app-question-dropdown>
            </div>
            <div class="form-group">
              <input currencyMask
                type="tel"
                [placeholder]="globalQuestionService.accounting.formatMoney(currentVap?.value_min) + ' - ' + globalQuestionService.accounting.formatMoney(currentVap?.value_max)"
                [options]="maskOptions"
                [(ngModel)]="item.benefit_value"
                [class]="'form-control amount answers ' + question?.cent_aq_question_id"
                (ngModelChange)="onChange(i, 0)"/>
              </div>
            </div>
          </div>
        </div>
      }
